import React, { FC, ChangeEvent } from 'react'
import { Form, Input } from 'antd';
import { NamePath } from 'antd/lib/form/interface';
import { Rule } from 'antd/lib/form';
import { normalizeInputLowercaseCharacter } from 'src/helpers/common.utils';

export interface ILowercaseInputProps {
	name: string | NamePath | undefined;
	initValue?: string | number | undefined;
	rules?: Rule[];
	placeholder?: string;
    tabIndex?: number | undefined;
    id?: string | undefined;
    type?: string | undefined;
    disabled?: boolean;
    onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
    value?: string | number | undefined;
}


const InputLowercase: FC<ILowercaseInputProps> = ({
    name,
    rules,
    placeholder,
    tabIndex,
    id,
    type,
    disabled,
    value,
    onChange
}) => {
    return (
        <>
            <Form.Item 
                name={name} 
                required={false} 
                rules={rules} 
                normalize={normalizeInputLowercaseCharacter}
            >
				<Input placeholder={placeholder} type={type} id={id} tabIndex={tabIndex} disabled={disabled} onChange={onChange} value={value} />
			</Form.Item>
        </>
    )
}

export default InputLowercase